import { render, staticRenderFns } from "./SelectOds.vue?vue&type=template&id=4ef17e9e&scoped=true"
import script from "./SelectOds.vue?vue&type=script&lang=js"
export * from "./SelectOds.vue?vue&type=script&lang=js"
import style0 from "./SelectOds.vue?vue&type=style&index=0&id=4ef17e9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef17e9e",
  null
  
)

export default component.exports